class Passkey {
    constructor() {
        this.loadPasskeyTable();
        this.checkForAnchor();
    }
    loadPasskeyTable(){
        let passkeyTab = document.querySelector('a[href="#passkeys_tab"]');
        passkeyTab.addEventListener("click", function() {
            new PasskeyDatatable();
        }, {once : true});
    }
    checkForAnchor(){
        if(window.location.hash === "#passkeys_tab"){
            //click on the tab
            let passkeyTab = document.querySelector('a[href="#passkeys_tab"]');
            passkeyTab.click();
        }
    }
}
window.Passkey = Passkey;